import { usePaging } from 'hooks/usePaging';
import { useGetOrganizationUnitTicketDefaultAssignsQuery } from 'services';
import { FindAllOrganizationUnitTicketDefaultAssignDto } from 'types';
import { DEFAULT_PAGE_SIZE } from 'utils';
const pageSize = DEFAULT_PAGE_SIZE;
export function useOrganizationUnitTicketDefaultAssignsPaging(
  params: Omit<FindAllOrganizationUnitTicketDefaultAssignDto, 'pageIndex' | 'pageSize'>
) {
  const { keyword } = params;
  const { pageIndex, changePage, resetPage } = usePaging(params);
  const {
    data: organizationUnitTicketDefaultAssignsResponse,
    error,
    isLoading,
    isFetching
  } = useGetOrganizationUnitTicketDefaultAssignsQuery({
    pageIndex: pageIndex,
    pageSize,
    keyword
  });
  const handleChangePage = changePage;

  return {
    organizationUnitTicketDefaultAssigns: organizationUnitTicketDefaultAssignsResponse?.data.rows,
    count: organizationUnitTicketDefaultAssignsResponse ? organizationUnitTicketDefaultAssignsResponse.data.count : 0,
    pageIndex,
    isLoading: isFetching || isLoading,
    error,
    handleChangePage,
    resetPage
  };
}
